import { CRITERIA, CRITERION_ROLES, type ContractRole } from '@eformulieren/model'

/**
 * De rol per eigenschap voor een subgrid op een reeks (D-73, R-62, R-137).
 *
 * **Eerst wat de publicatie zegt.** Sinds de poort de rollen uit de registry in de definitie
 * bevriest (`freezeSeriesRoles` in `packages/engine/src/seriesRoles.ts`), draagt de bron van elk
 * subgrid op een reeks ze mee, ook van een extern of ingericht bouwblok. Een leeg object is daar
 * een uitspraak: het contract kent de reeks en geeft geen eigenschap een rol, dus de platte tabel.
 *
 * **Daarna de terugval, en die houdt een oudere publicatie zoals ze was.** Een definitie die vóór
 * de bevriezing is gepubliceerd draagt geen `rollen`, en een pod wordt nooit bijgewerkt. Voor
 * haar geldt wat opdracht B3 bouwde: de door dit product gegenereerde `criteria`-eigenschap kent
 * haar rollen zonder contract (`CRITERION_ROLES`, D-42), elke andere reeks blijft plat.
 *
 * Een eigen bestand en niet in `FillForm.tsx`, zodat de schil en de modus met historie dezelfde
 * regel lezen.
 */
export function seriesRolesFor(
  source: { readonly pad: string; readonly rollen?: Readonly<Record<string, ContractRole>> | undefined } | null | undefined,
): Readonly<Record<string, ContractRole>> | undefined {
  if (source === null || source === undefined) return undefined
  if (source.rollen !== undefined) return source.rollen
  return source.pad === CRITERIA ? CRITERION_ROLES : undefined
}
